import * as warrantyErrorCodes from './warrantyErrorCodes';
import * as warrantyTasksCodes from './warrantyTasksCodes';

const reducers = {
  ...warrantyErrorCodes,
  ...warrantyTasksCodes,
};

export default reducers;
